import React from "react";
import { HashRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth, AuthProvider } from "./contexts/AuthContext";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import HomePage from "./pages/HomePage";
import AdminDashboard from "./pages/AdminDashboard";
import MahasiswaDashboard from "./pages/MahasiswaDashboard";
import DosenDashboard from "./pages/DosenDashboard";
import "./App.css";

function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFDFD]">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-[#002147] border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-[#475569] font-[Manrope]">Memuat...</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function RoleRedirect() {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFDFD]">
        <div className="w-8 h-8 border-2 border-[#002147] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  // Tidak login → tampilkan homepage
  if (!user) return <HomePage />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (user.role === "dosen") return <Navigate to="/dosen" replace />;
  return <Navigate to="/mahasiswa" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RoleRedirect />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/admin" element={
        <ProtectedRoute roles={["admin"]}>
          <AdminDashboard />
        </ProtectedRoute>
      } />
      <Route path="/mahasiswa" element={
        <ProtectedRoute roles={["mahasiswa"]}>
          <MahasiswaDashboard />
        </ProtectedRoute>
      } />
      <Route path="/dosen" element={
        <ProtectedRoute roles={["dosen"]}>
          <DosenDashboard />
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <HashRouter>
        <AppRoutes />
      </HashRouter>
    </AuthProvider>
  );
}
